<template>

    <div v-if="step" class="tuto-card-container">


        <div class="progress-container">

            <div :style="{ width: `${ step/4*100 }%` }" class="progress-ing"></div>

        </div>

        <div class="tuto-first-container">

            <div v-if="step && step < 4" class="steps-container">

                <div class="bloc-text">

                    <markdown :color="computedTextColor" :text="computedTitle" class="tuto-title cf-headline"></markdown>


                    <p class="tuto-text">{{ computedText }}</p>

                </div>

                <div class="card-container">

                    <img v-if="step === 1" :style="{ opacity: computedOpacityLeft }" class="tuto-arrow-left" src="/img/icons/arrow-left-red.svg">
                    <img v-if="step === 2" :style="{ opacity: computedOpacityTop }" class="tuto-arrow-top" src="/img/icons/arrow-top-amina.svg">
                    <img v-if="step === 3" :style="{ opacity: computedOpacityRight }" class="tuto-arrow-right" src="/img/icons/arrow-right-green.svg">

                    <vue-swing v-show="step === 1"
                               ref="vueswingLeft"
                               :config="config1"
                               class="swing"
                               @dragend="dragend"
                               @dragmove="dragmove"
                               @throwoutleft="nextStep">


                        <img class="tuto-card-img noselect img-noselect" src="/img/cards/tuto-cards.svg">


                    </vue-swing>

                    <vue-swing v-show="step === 2"
                               ref="vueswingTop"
                               :config="config2"
                               class="swing"
                               @dragend="dragend"
                               @dragmove="dragmove"
                               @throwoutup="nextStep">


                        <img class="tuto-card-img noselect img-noselect" src="/img/cards/tuto-cards.svg">


                    </vue-swing>

                    <vue-swing v-show="step === 3"
                               ref="vueswingRight"
                               :config="config3"
                               class="swing"
                               @dragend="dragend"
                               @dragmove="dragmove"
                               @throwoutright="nextStep">


                        <img class="tuto-card-img noselect img-noselect" src="/img/cards/tuto-cards.svg">


                    </vue-swing>

                    <img v-if="step < 2" class="tuto-card-img noselect img-noselect third-tuto-card" src="/img/cards/tuto-cards-3.svg">
                    <img v-if="step < 3" class="tuto-card-img noselect img-noselect second-tuto-card" src="/img/cards/tuto-cards-2.svg">

                </div>

                <div class="btn-container">

                    <div :class="{ 'btn-disable': step !== 1 }" class="bottom-btn-white">

                        <img class="bottom-btn-img-1" src="/img/icons/auto-delete-raspberry.svg">

                    </div>

                    <div :class="{ 'btn-disable': step !== 2 }" class="bottom-btn-white bottom-btn-little">

                        <img class="bottom-btn-img-2" src="/img/icons/trash-amina.svg">

                    </div>

                    <div :class="{ 'btn-disable': step !== 3 }" class="bottom-btn-white">

                        <img class="bottom-btn-img-3" src="/img/icons/keep-green.svg">

                    </div>

                </div>


            </div>

            <div v-if="step === 4" class="tuto-last-item">

                <div></div>

                <div>

                    <h2 class="tuto-title cf-title-2">{{ $tc('cleaning_cards_tuto_title', 0, {firstname}) }}</h2>
                    <p class="tuto-text">{{ $t('cleaning_cards_tuto_text') }}</p>

                </div>


                <div class="tuto-last-item-btn-container">

                    <img class="foxy-btn" src="/img/foxy/middle-smile.png">

                    <button class="btn btn-big btn-blue btn-foxy" @click="closeTuto">{{ $t('cleaning_cards_tuto_cta') }}</button>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

import Vuex from 'vuex'

import VueSwing from 'vue-swing'

import Storage from '@/helpers/storage'

import Markdown from '@/components/Markdown'

export default {

    name: 'tuto-card',

    components: {VueSwing, Markdown},

    computed: {

        computedTitle: function () {
            return this.step === 1 ? this.$t('cleaning_cards_tuto_autodelete_title')
                : this.step === 2 ? this.$t('cleaning_cards_tuto_delete_title')
                    : this.$t('cleaning_cards_tuto_keep_title')
        },

        computedTextColor: function () {
            return this.step === 1 ? '#f04871'
                : this.step === 2 ? '#f97716'
                    : '#00d191'
        },

        computedText: function () {
            return this.step === 1 ? this.$t('cleaning_cards_tuto_autodelete_description')
                : this.step === 2 ? this.$t('cleaning_cards_tuto_delete_description')
                    : this.$t('cleaning_cards_tuto_keep_description')
        },

        computedOpacityLeft: function () {

            return this.throwDirection === 'left' ? 1 - this.throwOutConfidence : 1
        },

        computedOpacityTop: function () {

            return this.throwDirection === 'up' ? 1 - this.throwOutConfidence : 1
        },

        computedOpacityRight: function () {

            return this.throwDirection === 'right' ? 1 - this.throwOutConfidence : 1
        }
    },

    data: () => {

        return {
            step: 0,
            throwDirection: '',
            throwOutConfidence: '',
            config1: {
                allowedDirections: [VueSwing.Direction.LEFT]
            },
            config2: {
                allowedDirections: [VueSwing.Direction.UP]
            },
            config3: {
                allowedDirections: [VueSwing.Direction.RIGHT]
            },
            firstname: ''
        }
    },

    created() {

        window.addEventListener('keydown', this.keydown)
    },

    mounted() {

        this.getUserAsync()
            .then(user => {
                this.firstname = user.firstname
            })
            .catch(() => {
            })
    },

    methods: {

        ...Vuex.mapActions([
            'getUserAsync'
        ]),

        keydown(event) {

            if (event.keyCode === 37 && this.step === 1) {

                this.step = 2

            } else if (event.keyCode === 38 && this.step === 2) {

                this.step = 3

            } else if (event.keyCode === 39 && this.step === 3) {

                this.step = 4

            }
        },

        start() {

            this.nextStep()
        },

        nextStep() {

            this.step = this.step + 1
        },

        closeTuto() {

            Storage.setItem('needTutoCard', false)
            this.$emit('close')
            this.step = 0
        },

        dragmove(value) {
            const directToString = String(value.throwDirection)
            switch (directToString) {
                case 'Symbol(UP)':
                    this.throwDirection = 'up'
                    break
                case 'Symbol(LEFT)':
                    this.throwDirection = 'left'
                    break
                case 'Symbol(RIGHT)':
                    this.throwDirection = 'right'
                    break
                case 'Symbol(DOWN)':
                    this.throwDirection = 'down'
                    break
                default:
                    this.throwDirection = ''
            }
            this.throwOutConfidence = value.throwOutConfidence.toFixed(2)

        },

        dragend() {

            this.throwDirection = ''
            this.throwOutConfidence = 0

        }

    },

    destroyed() {

        window.removeEventListener('keydown', this.keydown)
    }

}
</script>

<style lang="scss" scoped>

.tuto-card-container {
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    background-color: $timberwolf;
    display: flex;
    flex-direction: column;
    padding: 16px;
    @media screen and (min-width: $above-tablet-length) {
        position: absolute;

        background-image: url(/img/background/cards-desktop.svg);
        background-blend-mode: luminosity;
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: cover;
    }
}

.progress-container {
    height: 6px;
    background-color: #d0d2d8;
    border-radius: 3px;
    display: flex;
    flex-direction: row;
}

.progress-ing {
    height: 6px;
    background-color: $blue;
    border-radius: 3px;
}

.tuto-first-container {
    display: flex;
    flex-grow: 1;
    justify-content: center;
}

.bloc-text {
    height: 128px;
}

.steps-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    @media screen and (min-width: $above-tablet-length) {
        justify-content: space-evenly;
    }
}

.tuto-title {
    margin-top: 30px;
    color: $midnight;
}

.tuto-text {
    margin-top: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.17;
    color: $grey;
}

.card-container {
    width: 208px;
    height: 241px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.swing {
    width: 208px;
    height: 241px;
    z-index: 1;
    @media screen and (min-width: $above-tablet-length) {
        width: 320px;
        height: 368px;
    }
}

.tuto-card-img {
    width: 208px;
    object-fit: contain;
    @media screen and (min-width: $above-tablet-length) {
        width: 320px;
    }
}

.second-tuto-card {
    position: absolute;
    top: -8px;
    @media screen and (min-width: $above-tablet-length) {
        top: -72px;
    }
}

.third-tuto-card {
    position: absolute;
    top: -16px;
    @media screen and (min-width: $above-tablet-length) {
        top: -80px;
    }
}

.btn-container {
    width: 100%;
    height: 48px;
    max-width: 160px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    /*position: fixed;*/
    margin-bottom: 50px;
    @media screen and (min-width: $above-tablet-length) {
        max-width: 288px;
        height: 80px;
        margin-bottom: 0;
    }
}


.bottom-btn-white {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 100%;
    background-color: $white;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
    @media screen and (min-width: $above-tablet-length) {
        width: 80px;
        height: 80px;
    }
}

.tuto-last-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    flex-grow: 1;
}

.tuto-last-item-btn-container {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.foxy-btn {
    position: absolute;
    width: 300px;
    top: -72px;
}

.bottom-btn-little {
    width: 40px;
    height: 40px;
    @media screen and (min-width: $above-tablet-length) {
        width: 64px;
        height: 64px;
    }
}

.bottom-btn-img-1 {
    width: 32px;
    object-fit: contain;
}

.bottom-btn-img-2 {
    width: 28px;
    object-fit: contain;
}

.bottom-btn-img-3 {
    width: 36px;
    object-fit: contain;
}

.btn-img {
    width: 32px;
    object-fit: contain;
}

.bottom-btn-img-1 {
    height: 28px;
    object-fit: contain;
}

.bottom-btn-img-2 {
    height: 20px;
    object-fit: contain;
}

.bottom-btn-img-3 {
    height: 24px;
    object-fit: contain;
}

.btn-disable {
    opacity: 0.3;
    cursor: not-allowed;
}

.btn-foxy {
    @media screen and (min-width: $above-tablet-length) {
        max-width: 275px;
    }
}

.tuto-arrow-left {
    position: absolute;
    left: -24px;
    z-index: 2;
    animation: animleftarrow 1s ease-in-out 50ms infinite normal;
    @media screen and (min-width: $above-tablet-length) {
        animation: animleftarrowdesktop 1s ease-in-out 50ms infinite normal;
    }

}

.tuto-arrow-top {
    position: absolute;
    top: -24px;
    z-index: 2;
    animation: animtoparrow 1s ease-in-out 50ms infinite normal;
    @media screen and (min-width: $above-tablet-length) {
        animation: animtoparrowdesktop 1s ease-in-out 50ms infinite normal;
    }
}

.tuto-arrow-right {
    position: absolute;
    right: -24px;
    z-index: 2;
    animation: animrightarrow 1s ease-in-out 50ms infinite normal;
    @media screen and (min-width: $above-tablet-length) {
        animation: animrightarrowdesktop 1s ease-in-out 50ms infinite normal;
    }
}

@keyframes animleftarrow {
    0% {
        left: -24px;
    }
    50% {
        left: -48px;
    }
    100% {
        left: -24px
    }
}

@keyframes animtoparrow {
    0% {
        top: -24px;
    }
    50% {
        top: 0px;
    }
    100% {
        top: -24px
    }
}

@keyframes animrightarrow {
    0% {
        right: -24px;
    }
    50% {
        right: -48px;
    }
    100% {
        right: -24px
    }
}

@keyframes animleftarrowdesktop {
    0% {
        left: -76px;
    }
    50% {
        left: -94px;
    }
    100% {
        left: -76px;
    }
}

@keyframes animtoparrowdesktop {
    0% {
        top: -94px;
    }
    50% {
        top: -72px;
    }
    100% {
        top: -94px
    }
}

@keyframes animrightarrowdesktop {
    0% {
        right: -76x;
    }
    50% {
        right: -94px;
    }
    100% {
        right: -76x
    }
}

</style>
